import { render, staticRenderFns } from "./PersonProfileMasterMatchingInformation.vue?vue&type=template&id=43b163b4&scoped=true&"
import script from "./PersonProfileMasterMatchingInformation.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterMatchingInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterMatchingInformation.vue?vue&type=style&index=0&id=43b163b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b163b4",
  null
  
)

export default component.exports